module.exports = __webpack_public_path__ + "static/media/pr-features-bg.6cb8b6dc.png";